import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/WizardCampaign/ReviewAndLaunchStep'

export const FETCH_TEST_CAMPAIGN_RESULTS_ASYNC = createAsyncTypes(
  'FETCH_TEST_CAMPAIGN_RESULTS',
  typeKey
)

export const SEND_TRY_IT_OUT_ASYNC = createAsyncTypes('SEND_TRY_IT_OUT', typeKey)
export const CHANGE_TEST_SCENARIOS = `${typeKey}/CHANGE_TEST_SCENARIOS`
export const SET_ERROR = `${typeKey}/SET_ERROR`
